import { render, staticRenderFns } from "./BlockArea.vue?vue&type=template&id=c06ac578&scoped=true&"
import script from "./BlockArea.vue?vue&type=script&lang=js&"
export * from "./BlockArea.vue?vue&type=script&lang=js&"
import style0 from "./BlockArea.vue?vue&type=style&index=0&id=c06ac578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ac578",
  null
  
)

export default component.exports